
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

//AngularFire
import { AngularFireStorage } from '@angular/fire/storage';

import { ToasterService, OrderService  } from '../../_services';
import { NgxSpinnerService } from "ngx-spinner";

import { Observable } from 'rxjs';

@Component({
  selector: 'app-edit-order',
  templateUrl: './edit-order.component.html',
  styleUrls: ['./edit-order.component.scss']
})

export class EditOrderComponent implements OnInit {
  editOrderForm:FormGroup;
  orderId:string;
  orderData :any;
  constructor(
    public dialogRef: MatDialogRef<EditOrderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private _order : OrderService,
    private afStorage: AngularFireStorage,
    private spinner: NgxSpinnerService,
    private _toaster: ToasterService
  ) { }

  ngOnInit(): void {
    this.orderId = this.data.id;
    this.editOrderForm = this.formBuilder.group({
      first_name: [null, []],
      last_name: [null, []],
      email: [null, []],
      phone: [null, []],
      state : [null, []],
      shipping_address : [null,[]]
    })
    this.getOrderDetailById();
  }



  getOrderDetailById(){
    this.spinner.show();
    this._order.getOrderDetailById(this.orderId).subscribe(result=>{
      this.orderData = result;
      //Patch value
      if(this.orderData && this.orderData.length>0){
        this.editOrderForm.patchValue({
          first_name: this.orderData[0].payload.doc.data().first_name,
          last_name: this.orderData[0].payload.doc.data().last_name,
          email: this.orderData[0].payload.doc.data().email,
          phone: this.orderData[0].payload.doc.data().phone,
          state: this.orderData[0].payload.doc.data().state,
          shipping_address: this.orderData[0].payload.doc.data().shipping_address,
         
        });
      }

    this.spinner.hide();
    },err=>{
      alert("Something went wrong");
    })
  }



  hideDialog() {
    this.dialogRef.close();
  }

  async onFormSubmit(){
    this.spinner.show();
    const formData = this.editOrderForm.value;
    this._order.editOrder(formData,this.orderId).then(async (res:any) => {
      this.spinner.hide();
      this.dialogRef.close();
      this._toaster.showSuccess("Product edited successfully!", "Success");
    }).catch(err=>{
      this.spinner.hide();
      this.dialogRef.close();
      this._toaster.showError("'Product not edited!", "Error");
    })

  }

}
